import React,{ Component } from "react";

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";

import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';

import { logUser, logEmployee, registerEmployee } from '../store/actions/authAction'
import Basic from "../container/layouts/Basic";
import Notif from "./common/Notif";

import Login from "./Auth/Login";
import axios from "axios";
import Register from "./Auth/Register";

class LoginPage extends Component{
    state = {
        active: "login",
        email:"",
        username:"",
        lastname:"",
        password:"",
        password2:"",
        accept:"",
        rgpd:"",
        resetEmail: "",
        errors:{
            email:"",
            username:"",
            lastname:"",
            password:"",
            password2:"",
            accept:"",
            rgpd:"",
            resetEmail: "",
        },
        success:{
            email:"",
            username:"",
            password:"",
            password2:"",
        },
        notif: {
            open: false,
            variant:"",
            message: "",
        },
        openPassword: false,
    }   

    handleChange = (e) => {
        let field = e.target.name
        let value = e.target.value
        
        if(field === "email" || field === "resetEmail" ){
            value = value.toLowerCase().replace(/\s/g,"");
        }
        
        this.setState({
            [field]: value
        })
    }
    validEmail = (email, field = "email") => {
        let validEmail =  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        console.log("in check email", email);
        
        if(validEmail.test(String(email).toLowerCase())){
            console.log("valid email !");
            
            this.setState({
                success:"super email",
                errors:{
                    ...this.state.errors,
                    [field]:""
                }
            })
            return true
        } else {
            console.log("Bad email !");
            this.setState({
                errors:{
                    ...this.state.errors,
                    [field]:"Email incorrect"
                }
            }) 
        }
    }
    validPassword = (password) => {
        let isValid = true
        let re = /[0-9]/;
        if(!re.test(password)) {
            isValid = false
        }
        re = /[a-z]/;
        if(!re.test(password)) {
            isValid = false
        }
        re = /[A-z]/;
        if(!re.test(password)) {
            isValid = false
        }
        if(password.length < 6){
            isValid = false
        }
        let errMsg = isValid ? "" : "Le mot de passe doit contenir au minimum 6 caractères dont un chiffre, une majuscule et une minuscule"
        
        this.setState({
            errors:{
                ...this.state.errors,
                password:errMsg
            }
        }) 
        return isValid;
    }
    validate = (form) => {
        console.log('[Info],LoginPage,validate, entrer function,',{form});
        let noError = true
        let errors = {}
        let required = [
            "email", 
            "password",
        ]  
        
        required.map(field => {
            if(!this.state[field]){
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })
        console.log('[Info], validate submit ',{errors}, ' - ', noError);
        this.setState({
            errors
        })
        return noError
    }
    handleSubmit = async(form) => {
        if(this.validate(form)){

            // if (form === "login"){
            const resp = await this.props.logUser({email:this.state.email, user_password:this.state.password});
            if (resp === "ok"){
                return
            }

            const errorData = (resp && resp.data) || {};
            const errorCode = errorData.error_code;
            const errorMessage = typeof errorData.error === "string" ? errorData.error : "";
            console.log('[ERROR],LoginPage,handleSubmit,  err', errorCode || errorMessage);

            let msg = errorMessage
                ? "Un Problème est survenu  : "+errorMessage
                : "Un Problème est survenu, veuillez réessayer plus tard";
            if (errorCode === "WAITING_ACTIVATION"){
                msg = "Votre adresse email n'a pas encore été confirmée. Consultez votre boîte de réception (et vos spams) pour activer votre compte."
            } else if (errorMessage === "user and password don't match"){
                msg = "Un Problème est survenu  : Le mot de passe et l'email ne correspondent pas"
            }

            this.notif(true,"error",msg)
            return;
            // } 
        } else {
            this.notif(true,"error","Le Formulaire contient des erreurs")
        }
    }

    // handleResetPassword = async() => {
    //     if(this.validEmail(this.state.resetEmail, "resetEmail")){
    //         let res = await axios.post("/auth/reset/password",{email: this.state.resetEmail});
	// 		console.log({ res });
            
    //         if(res.data !== "OK"){
    //             this.notif(true,"error","Un Problème est survenu")
    //         } else {
    //             this.notif(true,"success","Un email vous a été envoyé pour réinitialiser votre mot de passe")
    //             this.clearForms()
    //         }
    //     } else {
    //         this.notif(true,"error","Le Formulaire contient des erreurs")
    //     }
    // }

    // clearForms = () => {
    //     this.setState({
    //         email:"",
    //         username:"",
    //         lastname:"",
    //         password:"",
    //         password2:"",
    //         accept:"",
    //         resetEmail: "",
    //         errors:{
    //             email:"",
    //             username:"",
    //             lastname:"",
    //             password:"",
    //             password2:"",
    //             accept:"",
    //             resetEmail: "",
    //         },
    //         openPassword: false,
    //     })
    // }

    notif = (open, variant, message) => {
        this.setState({
            notif:{
                open,
                variant,
                message
            }
        })
    }
    
    render(){
        const { active } = this.state
        const { open, variant, message } = this.state.notif
        return(
            <Basic page="login" noBanner>
                {(open && variant && message) && 
                    <Notif
                        open={open}
                        onClose={ () => this.notif(false) }
                        variant={variant}
                        message={message}
                    />
                }
               
                <Card className="login-form-box">
                    <CardHeader title={(this.state.active === "login" ? "Connexion" : "Espace Employés")}/>
                    <CardContent className="login-form">
                        {active === "login" && 
                            <Login 
                                handleChange={this.handleChange} 
                                handleSubmit={this.handleSubmit} 
                                handleReset={this.handleResetPassword} 
                                openForgetPassword={() => this.setState({
                                    openPassword: true
                                })}
                                closeForgetPassword={() => this.setState({
                                    openPassword: false
                                })}
                                {...this.state}
                            /> 
                        }
                        {active === "register" && 
                            <Register 
                                
                                notif={this.notif} 
                                // handleSubmit={this.handleSubmitEmployee} 
                                logEmployee={this.props.logEmployee}
                                registerEmployee={this.props.registerEmployee}
                            />
                        }    
                    </CardContent>
                    
                    {active === "login" &&
                        <CardActions>
                            <Button size="large" color="primary" href="/request-resetpwd"
                            >
                                Mots de passe oublié ?
                            </Button>
                            {/* <span>Pas encore de Compte ?</span> */}
                            <Button size="large" color="primary" onClick={
                                () => this.setState({
                                    active:"register"
                                })} style={{marginLeft: "auto"}} 
                            >
                                Espace Employés
                            </Button>
                        
                        </CardActions>
                    }
                    {active === "register" &&
                        <CardActions>
                            {/* <span>Vous avez deja un Compte ?</span> */}
                            <Button size="large" color="primary" onClick={
                                () => this.setState({
                                    active:"login"
                                })} style={{marginLeft: "auto"}} 
                            >
                                Espace Compta
                            </Button>
                        </CardActions>
                    }
                </Card>
            
            </Basic >
        )
    }
}

function mapStateToProps(state){
    return {
        page: state.page,
        STATE: state.request.users,
    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({
        logUser,
        logEmployee,
        registerEmployee
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LoginPage))